import { BookkeepingDetailSection } from "bookkeeping/BookkeepingDetailSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React, { useState } from "react";
import BookkeepingOptionsPanel from "../BookkeepingOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import LinkedItems from "company/detail/linkedItems/App";
import { isPanelVisible } from "utilities/panelUtils";
import { BookkeepingActivityPanel } from "bookkeeping/activity/BookkeepingActivityPanel";
import { VatRatesPanel } from "bookkeeping/VatRatesPanel";
import { useLoaderData } from "react-router";

export const BookkeepingDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BookkeepingDetailFrontModel>();

  const [companyAdmCountry, setCompanyAdmCountry] = useState<server.dto.Countries>(viewModel.bookkeeping.companyAdmCountry);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BookkeepingDetailSection
            bookkeeping={viewModel.bookkeeping}
            isLastVisible={viewModel.bookkeepingIsLastVisible}
            isUsedInDocuments={viewModel.bookkeepingIsUsedInDocuments}
            userIds={viewModel.userIds}
            users={viewModel.users}
            wordTemplateIds={viewModel.wordTemplateIds}
            wordTemplates={viewModel.wordTemplates}
            onCountryChanged={(country: server.dto.Countries) => setCompanyAdmCountry(country)}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <BookkeepingOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            bookkeepingId={viewModel.bookkeeping.bookkeepingId}
            isUsedInDocuments={viewModel.bookkeepingIsUsedInDocuments}
          />
          {isPanelVisible(viewModel.linkedItemCountPanelConfig) && <LinkedItems
            config={viewModel.linkedItemCountPanelConfig}
            linkedItems={viewModel.linkedCount}
          />}
          <VatRatesPanel country={companyAdmCountry} />
          {isPanelVisible(viewModel.activityPanel) && <BookkeepingActivityPanel
            config={viewModel.activityPanel}
            bookkeepingId={viewModel.bookkeeping.bookkeepingId}
          />}
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}